import { BuyTokenPackageDialogProps } from '@/components/BuyTokenPackageDialog'
import { BuyVipDialogV1Props } from '@/components/BuyVipDialogV1'
import { ExchangeCodeDialogProps } from '@/components/ExchangeCodeDialog'
import { PaySuccessEducationDiaLogProps } from '@/components/PaySuccessEducationDiaLog'
import { PaySuccessDialogProps } from '@/components/PaySuccessDialog'
import { PdfUpgradeModalProps } from '@/components/PdfUpgradeModal'
import { ModalProps } from 'antd'
import { MessageInstance } from 'antd/es/message/interface'
import { makeObservable, observable } from 'mobx'

interface CommonModalProps extends ModalProps {
  content?: string
}
class UiController {
  @observable message!: MessageInstance
  @observable commonModalProps: CommonModalProps = { open: false }
  @observable paySuccessDialogProps: PaySuccessDialogProps = {
    open: false,
  }

  @observable paySuccessEducationDialogProps: PaySuccessEducationDiaLogProps = {
    open: false,
  }

  @observable buyTokenPackageDialogProps: BuyTokenPackageDialogProps = {
    open: false,
  }

  @observable buyVipDialogV1Props: BuyVipDialogV1Props = {
    open: false,
  }

  @observable exchangeDialogProps: ExchangeCodeDialogProps = {
    open: false,
  }
  @observable pdfUploadTimeLimitedProps: PdfUpgradeModalProps = {
    open: false,
  }
  @observable pdfChatTimeLimited = false
  @observable pdfUploadPageLimitedProps: PdfUpgradeModalProps = {
    open: false,
  }
  public init() {
    makeObservable(this)
  }
}

export const uiController = new UiController()
